/* ==========================================================================
   LOVE LACE — motion engine (ll-motion.js)
   One passive scroll listener + one rAF loop; transforms / clip-path only.
   Everything is derived from scroll position, so scrolling up reverses it.
   Never hijacks native scrolling; honours prefers-reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var doc = document, win = window;
  var reduce = win.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = win.matchMedia('(hover: hover) and (pointer: fine)');
  var isReduced = function () { return reduce.matches; };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var ease = function (t) { return t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var vh = win.innerHeight;
  var ticking = false;
  var scrollJobs = [];

  function onFrame() {
    ticking = false;
    var y = win.pageYOffset;
    for (var i = 0; i < scrollJobs.length; i++) scrollJobs[i](y);
  }
  function requestTick() { if (!ticking) { ticking = true; win.requestAnimationFrame(onFrame); } }
  win.addEventListener('scroll', requestTick, { passive: true });
  win.addEventListener('resize', function () { vh = win.innerHeight; requestTick(); }, { passive: true });

  /* Announcement rotation (mobile) */
  function initAnnouncement() {
    doc.querySelectorAll('[data-ll-ann]').forEach(function (bar) {
      var items = bar.querySelectorAll('.ll-ann__track--mobile .ll-ann__item');
      if (items.length < 2 || isReduced()) return;
      var i = 0, paused = false, ms = parseInt(bar.dataset.interval, 10) || 4000;
      bar.addEventListener('mouseenter', function () { paused = true; });
      bar.addEventListener('mouseleave', function () { paused = false; });
      setInterval(function () {
        if (paused || doc.hidden) return;
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, ms);
    });
  }

  /* Header: shrink on scroll, mega menu, mobile menu */
  function initHeader() {
    var header = doc.querySelector('[data-ll-header]');
    if (!header) return;
    var scrim = doc.querySelector('[data-ll-scrim]');
    var scrolled = null;

    scrollJobs.push(function (y) {
      var s = y > 24;
      if (s !== scrolled) { scrolled = s; header.classList.toggle('is-scrolled', s); }
    });

    var items = header.querySelectorAll('[data-ll-mega-item]');
    var openItem = null, closeTimer = null, openTimer = null;
    function open(item) {
      clearTimeout(closeTimer);
      if (openItem === item) return;
      if (openItem) close(openItem, true);
      if (!item.querySelector('[data-ll-mega]')) return;
      openItem = item;
      item.classList.add('is-open');
      header.classList.add('is-open');
      var trigger = item.querySelector('.ll-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (scrim) scrim.classList.add('is-visible');
    }
    function close(item, swapping) {
      item.classList.remove('is-open');
      var trigger = item.querySelector('.ll-nav__link');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (openItem === item) openItem = null;
      if (!swapping) {
        header.classList.remove('is-open');
        if (scrim) scrim.classList.remove('is-visible');
      }
    }
    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(openTimer);
        openTimer = setTimeout(function () { open(item); }, openItem ? 0 : 90);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(openTimer);
        closeTimer = setTimeout(function () { close(item); }, 160);
      });
      item.addEventListener('focusin', function () { open(item); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openItem) {
        var t = openItem.querySelector('.ll-nav__link');
        close(openItem);
        if (t) t.focus();
      }
    });
    if (scrim) scrim.addEventListener('click', function () { if (openItem) close(openItem); });

    var mnav = doc.querySelector('[data-ll-mnav]');
    var burger = doc.querySelector('[data-ll-mnav-open]');
    if (mnav && burger) {
      var closeBtn = mnav.querySelector('[data-ll-mnav-close]');
      var openM = function () {
        mnav.hidden = false;
        requestAnimationFrame(function () { requestAnimationFrame(function () { mnav.classList.add('is-open'); }); });
        burger.setAttribute('aria-expanded', 'true');
        doc.body.classList.add('ll-lock');
        setTimeout(function () { closeBtn && closeBtn.focus(); }, 60);
      };
      var closeM = function () {
        mnav.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        doc.body.classList.remove('ll-lock');
        setTimeout(function () { if (!mnav.classList.contains('is-open')) mnav.hidden = true; }, 650);
        burger.focus();
      };
      burger.addEventListener('click', openM);
      closeBtn && closeBtn.addEventListener('click', closeM);
      mnav.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeM(); });
      initTabs(mnav.querySelector('[role="tablist"]'), mnav);
    }
  }

  /* accessible tabs (roving tabindex) */
  function initTabs(list, scope, onChange) {
    if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = scope.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
      if (onChange) onChange(tabs.indexOf(tab));
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') n = tabs[0];
        if (e.key === 'End') n = tabs[tabs.length - 1];
        if (n) { e.preventDefault(); select(n, true); }
      });
    });
  }

  /* Reveals — reversible (re-hide when element drops back below viewport) */
  var revealIO = null;
  function initReveals(scope) {
    var els = (scope || doc).querySelectorAll('.ll-reveal, .ll-mask, .ll-lines, [data-ll-reveal]');
    if (!els.length) return;
    if (isReduced() || !('IntersectionObserver' in win)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!revealIO) {
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) en.target.classList.add('is-in');
          else if (en.boundingClientRect.top > 0) en.target.classList.remove('is-in');
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    }
    els.forEach(function (el) { revealIO.observe(el); });
  }

  /* Parallax / zoom / drift — only while on screen */
  function trackVisible(selector, fn) {
    var els = Array.prototype.slice.call(doc.querySelectorAll(selector));
    if (!els.length) return;
    var visible = new Set();
    if ('IntersectionObserver' in win) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { en.isIntersecting ? visible.add(en.target) : visible.delete(en.target); });
        requestTick();
      }, { rootMargin: '20% 0px 20% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else { els.forEach(function (el) { visible.add(el); }); }
    scrollJobs.push(function () { visible.forEach(fn); });
  }
  function initParallax() {
    if (isReduced()) return;
    trackVisible('[data-ll-parallax]', function (el) {
      var speed = parseFloat(el.getAttribute('data-ll-parallax')) || 0.1;
      if (win.innerWidth < 750) speed *= 0.5;
      var r = el.parentElement.getBoundingClientRect();
      var center = r.top + r.height / 2 - vh / 2;
      el.style.transform = 'translate3d(0,' + (-center * speed).toFixed(1) + 'px,0)';
    });
    trackVisible('[data-ll-zoom]', function (el) {
      var r = el.parentElement.getBoundingClientRect();
      var p = clamp((vh - r.top) / (vh + r.height * 0.5), 0, 1);
      el.style.setProperty('--z', ease(p).toFixed(3));
    });
    trackVisible('[data-ll-drift-x]', function (el) {
      var r = el.getBoundingClientRect();
      var p = clamp((vh - r.top) / (vh + r.height), 0, 1);
      if (el.classList.contains('ll-footer__brand')) el.style.transform = 'translate3d(' + ((0.5 - p) * 120).toFixed(1) + 'px,0,0)';
      else el.style.setProperty('--dx', ((0.5 - p) * win.innerWidth * 0.35).toFixed(1));
    });
  }

  /* SIGNATURE SCROLL HERO */
  function initHero(scope) {
    (scope || doc).querySelectorAll('[data-ll-hero]').forEach(function (hero) {
      if (hero.__ll) return; hero.__ll = true;
      var track = hero.querySelector('.ll-hero__track');
      var layers = Array.prototype.slice.call(hero.querySelectorAll('[data-ll-layer]'));
      var texts = Array.prototype.slice.call(hero.querySelectorAll('[data-ll-text]'));
      var media = layers.map(function (l) { return l.querySelector('.ll-hero__media'); });
      var jumps = Array.prototype.slice.call(hero.querySelectorAll('[data-ll-jump]'));
      var drift = hero.querySelector('[data-ll-drift]');
      var cue = hero.querySelector('[data-ll-cue]');
      var bar = hero.querySelector('[data-ll-hero-bar]');
      var n = layers.length;
      if (n < 2) return;

      var video = hero.querySelector('[data-ll-desktop-video]');
      if (video) {
        if (win.innerWidth >= 990 && !isReduced()) { video.preload = 'auto'; video.load(); var pp = video.play(); if (pp && pp.catch) pp.catch(function () {}); }
        else { video.remove(); }
      }

      if (isReduced()) {
        hero.classList.add('is-static');
        texts.forEach(function (t, i) {
          var img = layers[i] && layers[i].querySelector('img');
          if (img) t.style.setProperty('--bgimg', 'url("' + (img.currentSrc || img.src) + '")');
          var cta = t.querySelector('[data-ll-scene-cta]'); if (cta) cta.removeAttribute('tabindex');
        });
        return;
      }

      /* warm the scene images shortly after load so transitions never show blanks */
      win.addEventListener('load', function () {
        setTimeout(function () { hero.querySelectorAll('.ll-hero__layer img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); }, 600);
      });

      var lastActive = -1;
      function render() {
        var rect = track.getBoundingClientRect();
        var range = rect.height - vh;
        if (rect.bottom < -50 || rect.top > vh + 50) return;
        var p = range > 0 ? clamp(-rect.top / range, 0, 1) : 0;
        var s = p * (n - 1);

        for (var i = 1; i < n; i++) {
          var r = ease(clamp(s - (i - 1), 0, 1));
          layers[i].style.setProperty('--r', r.toFixed(4));
          media[i - 1].style.setProperty('--y', (-r * 8).toFixed(2));
        }
        media[0].style.setProperty('--k', (Math.min(s, 1) * 0.06).toFixed(4));

        var active = Math.round(s);
        texts.forEach(function (t, i) {
          var d = s - i;
          var a = clamp(1 - Math.abs(d) * 2.2, 0, 1);
          if (i === 0) a = clamp(1 - s * 2.2, 0, 1);
          t.style.setProperty('--a', a.toFixed(3));
          t.style.setProperty('--dir', d < 0 ? 1 : -1);
          t.classList.toggle('is-visible', a > 0.01);
          t.classList.toggle('is-active', a > 0.6);
          var cta = t.querySelector('[data-ll-scene-cta]');
          if (cta) cta.tabIndex = a > 0.6 ? 0 : -1;
        });
        if (drift) {
          drift.style.setProperty('--dx', (s * 26).toFixed(2));
          drift.style.setProperty('--da', clamp(s * 1.5, 0, 1).toFixed(3));
        }
        if (cue) cue.style.setProperty('--cue', clamp(s * 3, 0, 1).toFixed(3));
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(3) + ')';
        if (active !== lastActive) {
          lastActive = active;
          jumps.forEach(function (j) { j.classList.toggle('is-active', +j.dataset.llJump === active); });
        }
      }
      scrollJobs.push(render);
      render();

      jumps.forEach(function (j) {
        j.addEventListener('click', function (e) {
          var idx = +j.dataset.llJump;
          if (idx === lastActive) return;
          e.preventDefault();
          var top = track.getBoundingClientRect().top + win.pageYOffset;
          var range = track.offsetHeight - vh;
          win.scrollTo({ top: top + range * (idx / (n - 1)) + 2, behavior: 'smooth' });
        });
      });
    });
  }

  /* Change the look */
  function initLook(scope) {
    (scope || doc).querySelectorAll('[data-ll-look]').forEach(function (sec) {
      if (sec.__ll) return; sec.__ll = true;
      var imgs = sec.querySelectorAll('[data-ll-look-img]');
      var count = sec.querySelector('[data-ll-look-n]');
      var current = 0;
      initTabs(sec.querySelector('[role="tablist"]'), sec, function (i) {
        if (i === current) return;
        var prev = imgs[current], next = imgs[i];
        imgs.forEach(function (im) { im.classList.remove('is-leaving'); });
        if (prev) { prev.classList.remove('is-active'); prev.classList.add('is-leaving'); prev.setAttribute('aria-hidden', 'true'); }
        if (next) {
          var lazy = next.querySelector('img[loading="lazy"]'); if (lazy) lazy.loading = 'eager';
          next.classList.add('is-active'); next.setAttribute('aria-hidden', 'false');
        }
        setTimeout(function () { if (prev) prev.classList.remove('is-leaving'); }, 1100);
        current = i;
        if (count) count.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
      });
      if ('IntersectionObserver' in win) {
        var io = new IntersectionObserver(function (en) {
          if (en[0].isIntersecting) { sec.querySelectorAll('.ll-look__img img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; }); io.disconnect(); }
        }, { rootMargin: '400px 0px' });
        io.observe(sec);
      }
    });
  }

  /* Carousels (native scroll + arrows + progress) */
  function initCarousels(scope) {
    (scope || doc).querySelectorAll('[data-ll-carousel]').forEach(function (c) {
      if (c.__ll) return; c.__ll = true;
      var track = c.querySelector('[data-ll-track]');
      if (!track) return;
      var prev = c.querySelector('[data-ll-prev]'), next = c.querySelector('[data-ll-next]');
      var prog = c.querySelector('[data-ll-progress]');
      function step() {
        var slide = track.children[0];
        if (!slide) return track.clientWidth * .8;
        var w = slide.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 16);
        return w * Math.max(1, Math.floor(track.clientWidth / w));
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var p = max > 0 ? track.scrollLeft / max : 1;
        if (prog) {
          var vis = track.scrollWidth ? Math.max(track.clientWidth / track.scrollWidth, 0.08) : 1;
          prog.style.setProperty('--p', (vis + (1 - vis) * p).toFixed(3));
        }
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      }
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: isReduced() ? 'auto' : 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: isReduced() ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { win.requestAnimationFrame(update); }, { passive: true });
      win.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* Mouse tilt + editorial cursor — desktop only */
  function initPointer() {
    if (!finePointer.matches || isReduced()) return;
    doc.querySelectorAll('[data-ll-tilt]').forEach(function (el) {
      var target = el.querySelector('[data-ll-tilt-target]') || el;
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        target.style.setProperty('--tx', (x * -18).toFixed(1) + 'px');
        target.style.setProperty('--ty', (y * -18).toFixed(1) + 'px');
      });
      el.addEventListener('mouseleave', function () { target.style.setProperty('--tx', '0px'); target.style.setProperty('--ty', '0px'); });
    });

    var header = doc.querySelector('[data-ll-header]');
    var cursor = doc.querySelector('[data-ll-cursor]');
    if (!cursor || (header && header.dataset.cursorEnabled === 'false')) return;
    var label = cursor.querySelector('span');
    var shown = false, x = 0, y = 0, raf = null;
    doc.addEventListener('mousemove', function (e) {
      x = e.clientX; y = e.clientY;
      var t = e.target.closest && e.target.closest('[data-cursor]');
      var interactive = e.target.closest && e.target.closest('button, input, select, textarea, .ll-card__actions, .ll-card__wish, .ll-card__info');
      var want = !!t && !interactive;
      if (want) {
        var txt = t.getAttribute('data-cursor');
        if (label.textContent !== txt) label.textContent = txt;
        cursor.classList.toggle('ll-cursor--dark', !!t.closest('.ll-card'));
      }
      if (want !== shown) { shown = want; cursor.classList.toggle('is-visible', want); }
      if (!raf) raf = requestAnimationFrame(function () { raf = null; cursor.style.setProperty('--x', x + 'px'); cursor.style.setProperty('--y', y + 'px'); });
    }, { passive: true });
    doc.addEventListener('mouseleave', function () { shown = false; cursor.classList.remove('is-visible'); });
  }

  function init() {
    initAnnouncement();
    initHeader();
    initHero();
    initLook();
    initCarousels();
    initReveals();
    initParallax();
    initPointer();
    requestTick();
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();

  doc.addEventListener('shopify:section:load', function (e) { initHero(e.target); initLook(e.target); initCarousels(e.target); initReveals(e.target); requestTick(); });
  win.LoveLaceMotion = { initCarousels: initCarousels, initReveals: initReveals };
})();
